import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "form-group mb-2 me-2 col-md-4 col-lg-4 col-xl-3" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "form-group mb-2 col" }
const _hoisted_10 = { class: "col-auto p-0 text-end" }
const _hoisted_11 = { class: "col-sm-12" }
const _hoisted_12 = { class: "card card-body" }
const _hoisted_13 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { class: "overflow-auto" }
const _hoisted_17 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_18 = { class: "text-capitalize-first" }
const _hoisted_19 = { class: "text-capitalize-first" }
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "text-capitalize-first" }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = { class: "text-capitalize-first" }
const _hoisted_24 = { class: "text-capitalize-first" }
const _hoisted_25 = { class: "text-capitalize-first" }
const _hoisted_26 = { class: "text-capitalize-first" }
const _hoisted_27 = { class: "text-capitalize-first" }
const _hoisted_28 = { class: "text-capitalize-first" }
const _hoisted_29 = { class: "text-capitalize-first" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  colspan: "13",
  class: "text-center text-muted"
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "table table-striped border-light mt-3" }
const _hoisted_36 = { class: "text-capitalize-first w-50" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "pageLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_TraderMultiselect, {
                        multiple: true,
                        modelValue: _ctx.tradersFilter,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tradersFilter) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.applyFilters()), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.clearFilters()), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.helper.trans('requisites.templates.title')), 1),
                  _createElementVNode("small", _hoisted_15, _toDisplayString(_ctx.helper.trans('requisites.templates.admin.readonly_hint')), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("table", _hoisted_17, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                        _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.helper.trans('requisites.templates.admin.trader')), 1),
                        _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.helper.trans('requisites.templates.name')), 1),
                        _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.helper.trans('labels.currency')), 1),
                        _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.helper.trans('labels.payment_option')), 1),
                        _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.helper.trans('requisites.templates.field.method')), 1),
                        _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.helper.trans('labels.req_group')), 1),
                        _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.helper.trans('labels.device')), 1),
                        _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.helper.trans('labels.min_pay_in_deal_sum')), 1),
                        _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.helper.trans('labels.max_pay_in_deal_sum')), 1),
                        _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.helper.trans('requisites.templates.admin.created_at')), 1),
                        _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.helper.trans('requisites.templates.admin.updated_at')), 1),
                        _cache[6] || (_cache[6] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_ctx.loaded && _ctx.templates.items.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                            _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.helper.trans('requisites.templates.empty')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates.items, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.id), 1),
                          _createElementVNode("td", null, [
                            (_ctx.tradersById[item.traderId])
                              ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                  key: 0,
                                  user: _ctx.tradersById[item.traderId]
                                }, null, 8, ["user"]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_32, "#" + _toDisplayString(item.traderId), 1))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.name), 1),
                          _createElementVNode("td", null, _toDisplayString(item.currency ?? '-'), 1),
                          _createElementVNode("td", null, _toDisplayString(item.paymentOption ? _ctx.helper.trans('payment_options.' + item.paymentOption) : '-'), 1),
                          _createElementVNode("td", null, _toDisplayString(item.method ? _ctx.helper.trans('pay_methods.' + item.method) : '-'), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.groupName(item.groupId)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.deviceName(item.deviceId)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatNumber(item.minPayInDealSum)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatNumber(item.maxPayInDealSum)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.createdAt)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.updatedAt)), 1),
                          _createElementVNode("td", _hoisted_33, [
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.showTemplate(item)),
                              class: "btn btn-sm btn-outline-dark text-nowrap text-capitalize-first"
                            }, [
                              _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fa fa-eye me-1" }, null, -1)),
                              _createTextVNode(_toDisplayString(_ctx.helper.trans('requisites.templates.admin.view')), 1)
                            ], 8, _hoisted_34)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                (_ctx.templates.totalCount > _ctx.templates.items.length)
                  ? (_openBlock(), _createBlock(_component_b_pagination, {
                      key: 0,
                      modelValue: _ctx.page,
                      "onUpdate:modelValue": [
                        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page) = $event)),
                        _cache[4] || (_cache[4] = ($event: any) => (_ctx.load()))
                      ],
                      "total-rows": _ctx.templates.totalCount,
                      "per-page": _ctx.templates.limit,
                      limit: 20,
                      "prev-text": _ctx.helper.trans('button.back'),
                      "next-text": _ctx.helper.trans('button.next'),
                      align: "start",
                      "first-number": "",
                      "hide-goto-end-buttons": "",
                      "hide-ellipsis": ""
                    }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_b_modal, {
        "dialog-class": "modal-lg",
        title: _ctx.current ? `${_ctx.helper.trans('requisites.templates.title')}: ${_ctx.current.name}` : '',
        modelValue: _ctx.current !== null,
        "body-class": "pt-0",
        "onUpdate:modelValue": _ctx.onModalToggle
      }, {
        default: _withCtx(() => [
          _createElementVNode("table", _hoisted_35, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailRows, (row) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.label
                }, [
                  _createElementVNode("th", _hoisted_36, _toDisplayString(row.label), 1),
                  _createElementVNode("td", null, _toDisplayString(row.value), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onModalToggle(false))),
            class: "btn btn-outline-secondary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.close')), 1)
        ]),
        _: 1
      }, 8, ["title", "modelValue", "onUpdate:modelValue"])
    ]),
    _: 1
  }, 512))
}